var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.19617e-05 24L7.13097 28.012L2.4606 34.6826L10.6527 35.2293L9.37397 43.2442L16.9977 40.236L19.3646 48L24.9056 42.0134L30.4466 48L32.8135 40.236L40.4342 43.2442L39.1586 35.2293L47.3476 34.6826L42.6803 28.012L49.8113 24L42.6803 19.988L47.3476 13.3174L39.1586 12.7707L40.4342 4.75877L32.8135 7.76699L30.4466 0L24.9056 5.98655L19.3646 0L16.9977 7.76699L9.37397 4.75877L10.6527 12.7707L2.4606 13.3174L7.13097 19.988L-4.19617e-05 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePolygon);
export default __webpack_public_path__ + "static/media/white-polygon.6c7889e4a662e7a7c99145fd9f9c6494.svg";
export { ForwardRef as ReactComponent };